export class SetNewPassword {
    email: string = '';
    password: string = '';
    token: string = '';
    utilityId: number;
} 